'use client';

import { useTranslations } from 'next-intl';
import { FeatureDetailContent } from './FeatureDetailContent';
import {
    ShoppingCart,
    Package,
    TrendingUp,
    Users,
    BarChart,
    Zap
} from 'lucide-react';

export function IntegrationWithEcommerceSolutionsContent() {
    const t = useTranslations('integrationWithEcommerceSolutions');

    const features = [
        {
            icon: ShoppingCart,
            title: t('features.step1.title'),
            description: t('features.step1.description'),
        },
        {
            icon: Package,
            title: t('features.step2.title'),
            description: t('features.step2.description'),
        },
        {
            icon: TrendingUp,
            title: t('features.step3.title'),
            description: t('features.step3.description'),
        },
        {
            icon: Users,
            title: t('features.step4.title'),
            description: t('features.step4.description'),
        },
        {
            icon: BarChart,
            title: t('features.step5.title'),
            description: t('features.step5.description'),
        },
        {
            icon: Zap,
            title: t('features.step6.title'),
            description: t('features.step6.description'),
        },
    ];

    // Get benefits list from translations, ensuring it's always an array
    const benefitsRaw = t.raw('benefits.list');
    const benefits = Array.isArray(benefitsRaw) ? benefitsRaw : (benefitsRaw ? [benefitsRaw] : []);

    return (
        <FeatureDetailContent
            pageKey="integration-with-e-commerce-solutions"
            translationNamespace="integrationWithEcommerceSolutions"
            features={features}
            benefits={benefits}
            ctaIcon={ShoppingCart}
            showWhatIsBitcoin={false}
            introImageSrc="/images/features/E-Commerce.webp"
            introImageAlt={t('intro.imageAlt') || 'Integration with E-commerce Solutions in MLM Software'}
            introParagraphKeys={['paragraph2', 'paragraph3']}
            introSectionHeadingPage="integration-with-e-commerce-solutions"
            introSectionHeadingTitle={t('intro.sectionHeadingTitle') || 'About Integration with E-commerce Solutions'}
            introSectionHeadingPill={t('intro.sectionHeadingPill') || 'E-commerce Integration'}
            useLocaleContent={true}
        />
    );
}

